import React = require('react');
import { MTACoverDetails } from './MTACoverDetails';
import { MTATravellerDetails } from './MTATravellerDetails';
import { concat } from 'lodash';
import { MTAOptionDetails } from './MTAOptionDetails';

interface IPolicyOverview {
  policyApplication: any;
  selectedScheme: any;
  noPadding?: boolean;
}

export const MTASummaryOverview = ({ policyApplication, selectedScheme, noPadding = false }: IPolicyOverview) => {

  if (!policyApplication) {
    return null;
  }

  const metadata = policyApplication.metadata;
  const isAnnual = metadata.scheme_type === 'annual';
  const travellers = concat(metadata.adults, metadata.children)

  return (
    <>
      <MTACoverDetails
        metadata={metadata}
        selectedScheme={selectedScheme}
        policyApplication={policyApplication}
        isAnnual={isAnnual}
        noPadding={noPadding}
      />
      <MTATravellerDetails
        travellers={travellers}
        noPadding={noPadding}
      />
      <MTAOptionDetails
        options={metadata?.options}
        noPadding={noPadding}
      />
    </>
  )
}
